import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getIntegrationIdsByItemIds } from '@/lib/api/work-integrations/workIntegrationItems';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetWorkIntegrationIdsByItemIds = (
  itemIds: number[],
  queryOptions: Omit<UseQueryOptions<Record<number, number>, Error>, 'queryFn' | 'queryKey'> = {},
) => {
  const allItemIdsSet = useMemo(() => new Set(itemIds), [itemIds]);

  return useQuery<Record<number, number>, Error>({
    queryKey: workIntegrationsQueryKeys.workIntegrationItems({ itemIds: allItemIdsSet }),
    queryFn: () =>
      getIntegrationIdsByItemIds({
        itemIds: allItemIdsSet,
      }),
    enabled: allItemIdsSet.size > 0,
    ...queryOptions,
  });
};
